import React from 'react';

import { Link } from "react-router-dom";

import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';
import { PortableText } from '@portabletext/react';

export default function PageNotFound() {
    const images = useImages();

    if (!Array.isArray(images) || !images.length) {
        return <div>Loading...</div>;
    }

    // Helper function to find an image by title
    const getImageByTitle = (title) => {
        return images.find((image) => image.title === title);
    };

    const logo = getImageByTitle('Page Not Found');


    return (
        <>
            <section className="section-padding">
                <div className="section-title text-gradient text-center">{logo.sectionTitle}</div>
                <div className="section-subTitle text-center padd-title">
                {logo?.content ? (
                                     <PortableText
                                       value={logo.content}
                                       components={{
                                         block: {
                                           normal: ({ children }) => <p>{children}</p>,
                                           h1: ({ children }) => <h1>{children}</h1>,
                                           h2: ({ children }) => <h2>{children}</h2>,
                                         },
                                         marks: {
                                           link: ({ children, value }) => (
                                             <a
                                               href={value.href}
                                               target="_blank"
                                               rel="noopener noreferrer"
                                               className="text-blue-500"
                                             >
                                               {children}
                                             </a>
                                           ),
                                         },
                                       }}
                                     />
                                   ) : 'Default description'}
                               </div>
                <div className="text-center notfound-img">
                    {logo && (

                        <img
                            src={urlFor(logo.file.asset).width(500).url()}
                            alt={logo.altText || 'Sanity Image'}
                        />

                    )}
                </div>
                <div className="text-center">
                    <Link to="/" smooth={true} duration={500} className="panacea-arrow-link">
                        {logo.btnlabel} <i className="bx bxs-right-top-arrow-circle"></i>
                    </Link>
                </div>

            </section>
        </>
    )
}
